/* eslint-disable */
import { getENV } from "../utils/env";

const baseUrl = {
  development: process.env.VUE_APP_CSP_BASEURL_DEV,
  preview: process.env.VUE_APP_CSP_BASEURL,
  production: process.env.VUE_APP_CSP_BASEURL,
}[getENV()];

export function test () {
  return $CA.util.netWork.get(`${ process.env.VUE_APP_BASEURL }/getStatus/200?time=3000`)
}

export function test2 () {
  return $CA.util.netWork.get(`${ process.env.VUE_APP_BASEURL }/getStatus/200?time=4000`)
}

export function getCspWordText ({ platformKey, businessType, path }) {
  return $CA.util.netWork.get(`${baseUrl}?platformKey=${platformKey}&businessType=${businessType}&path=${ path }`)
  // return $CA.util.netWork.get(`${process.env.VUE_APP_CSP_BASEURL}?platformKey=${platformKey}&businessType=${businessType}&path=${ path }`)
}

